import { BadgeFillKind, BadgePlacement } from "services/menuItemBadges/restModels";
import { RadioOption } from "shared/ui";

export const BADGE_PLACEMENT_OPTIONS: RadioOption<BadgePlacement>[] = [
    {
        value: "OverPhoto",
        label: "Поверх фото",
        description: "Плашка в углу фотографии. У позиции без фото встанет в строку под названием",
    },
    {
        value: "Inline",
        label: "Строкой под названием",
        description: "Рядом со временем приготовления",
    },
];

export const BADGE_FILL_KIND_OPTIONS: RadioOption<BadgeFillKind>[] = [
    { value: "Solid", label: "Однотонная" },
    { value: "Gradient", label: "Градиент" },
];

export const DEFAULT_BADGE_COLOR = "#49BC13";
